module.exports = __webpack_public_path__ + "img/service-banner10.c83c4590.png";